import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { AnchorHref } from './types'

export function useAnchorMenu() {
  const analyticsClient = useCommonDependency('analyticsClient')

  return {
    handleAnchorClick: (anchor: AnchorHref) => {
      analyticsClient.sendEvent(
        createPDPClickEvent({
          element: 'Element clicked',
          description: `Click to anchor nav menu, on ${anchor}`,
          result: `Goes to section of ${anchor}`,
          type: 'click',
        }),
      )
    },
  }
}
